//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.2.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class CommonShiftClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    createCommonShift(model: CommonShiftCreateItem): Promise<CommonShiftItem> {
        let url_ = this.baseUrl + "/workschedule/api/commonshift";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateCommonShift(_response);
        });
    }

    protected processCreateCommonShift(response: Response): Promise<CommonShiftItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonShiftItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommonShiftItem>(null as any);
    }

    updateCommonShift(model: CommonShiftUpdateItem): Promise<CommonShiftItem> {
        let url_ = this.baseUrl + "/workschedule/api/commonshift";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCommonShift(_response);
        });
    }

    protected processUpdateCommonShift(response: Response): Promise<CommonShiftItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonShiftItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommonShiftItem>(null as any);
    }

    getCommonShift(id: number): Promise<CommonShiftItem> {
        let url_ = this.baseUrl + "/workschedule/api/commonshift/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCommonShift(_response);
        });
    }

    protected processGetCommonShift(response: Response): Promise<CommonShiftItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonShiftItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommonShiftItem>(null as any);
    }

    deleteCommonShift(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/workschedule/api/commonshift/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteCommonShift(_response);
        });
    }

    protected processDeleteCommonShift(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    listCommonShifts(organizationId: number): Promise<CommonShiftListItem[]> {
        let url_ = this.baseUrl + "/workschedule/api/commonshift/list/organization/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListCommonShifts(_response);
        });
    }

    protected processListCommonShifts(response: Response): Promise<CommonShiftListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommonShiftListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommonShiftListItem[]>(null as any);
    }

    listAreaInheritedCommonShifts(areaId: number): Promise<CommonShiftListItem[]> {
        let url_ = this.baseUrl + "/workschedule/api/commonshift/list/area/{areaId}";
        if (areaId === undefined || areaId === null)
            throw new Error("The parameter 'areaId' must be defined.");
        url_ = url_.replace("{areaId}", encodeURIComponent("" + areaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListAreaInheritedCommonShifts(_response);
        });
    }

    protected processListAreaInheritedCommonShifts(response: Response): Promise<CommonShiftListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommonShiftListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommonShiftListItem[]>(null as any);
    }

    createCommonShiftInheritance(model: CommonShiftInheritanceCreateItem): Promise<CommonShiftInheritanceItem> {
        let url_ = this.baseUrl + "/workschedule/api/commonshift/inheritance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateCommonShiftInheritance(_response);
        });
    }

    protected processCreateCommonShiftInheritance(response: Response): Promise<CommonShiftInheritanceItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonShiftInheritanceItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommonShiftInheritanceItem>(null as any);
    }

    updateCommonShiftInheritance(model: CommonShiftInheritanceUpdateItem): Promise<CommonShiftInheritanceItem> {
        let url_ = this.baseUrl + "/workschedule/api/commonshift/inheritance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCommonShiftInheritance(_response);
        });
    }

    protected processUpdateCommonShiftInheritance(response: Response): Promise<CommonShiftInheritanceItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonShiftInheritanceItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommonShiftInheritanceItem>(null as any);
    }

    getCommonShiftInheritance(id: number): Promise<CommonShiftInheritanceItem> {
        let url_ = this.baseUrl + "/workschedule/api/commonshift/inheritance/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCommonShiftInheritance(_response);
        });
    }

    protected processGetCommonShiftInheritance(response: Response): Promise<CommonShiftInheritanceItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonShiftInheritanceItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommonShiftInheritanceItem>(null as any);
    }

    deleteCommonShiftInheritance(id: number): Promise<CommonShiftInheritanceItem> {
        let url_ = this.baseUrl + "/workschedule/api/commonshift/inheritance/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteCommonShiftInheritance(_response);
        });
    }

    protected processDeleteCommonShiftInheritance(response: Response): Promise<CommonShiftInheritanceItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonShiftInheritanceItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommonShiftInheritanceItem>(null as any);
    }

    getCommonShiftInheritanceOnArea(areaId: number, commonShiftId: number): Promise<CommonShiftInheritanceItem> {
        let url_ = this.baseUrl + "/workschedule/api/commonshift/inheritance/area/{areaId}/commonShift/{commonShiftId}";
        if (areaId === undefined || areaId === null)
            throw new Error("The parameter 'areaId' must be defined.");
        url_ = url_.replace("{areaId}", encodeURIComponent("" + areaId));
        if (commonShiftId === undefined || commonShiftId === null)
            throw new Error("The parameter 'commonShiftId' must be defined.");
        url_ = url_.replace("{commonShiftId}", encodeURIComponent("" + commonShiftId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCommonShiftInheritanceOnArea(_response);
        });
    }

    protected processGetCommonShiftInheritanceOnArea(response: Response): Promise<CommonShiftInheritanceItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonShiftInheritanceItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommonShiftInheritanceItem>(null as any);
    }

    listNonInheritedCommonShifts(areaId: number): Promise<CommonShiftListItem[]> {
        let url_ = this.baseUrl + "/workschedule/api/commonshift/inheritance/list/area/{areaId}";
        if (areaId === undefined || areaId === null)
            throw new Error("The parameter 'areaId' must be defined.");
        url_ = url_.replace("{areaId}", encodeURIComponent("" + areaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListNonInheritedCommonShifts(_response);
        });
    }

    protected processListNonInheritedCommonShifts(response: Response): Promise<CommonShiftListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommonShiftListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommonShiftListItem[]>(null as any);
    }

    listInheritedCommonShifts(organizationId: number): Promise<CommonShiftInheritanceItem[]> {
        let url_ = this.baseUrl + "/workschedule/api/commonshift/inheritance/list/organization/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListInheritedCommonShifts(_response);
        });
    }

    protected processListInheritedCommonShifts(response: Response): Promise<CommonShiftInheritanceItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommonShiftInheritanceItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommonShiftInheritanceItem[]>(null as any);
    }

    hasInheritanceOnCommonShift(id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/workschedule/api/commonshift/{id}/inheritance/exists";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHasInheritanceOnCommonShift(_response);
        });
    }

    protected processHasInheritanceOnCommonShift(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    connectCommonShiftsToAreas(model: CommonShiftsToAreasItem): Promise<boolean> {
        let url_ = this.baseUrl + "/workschedule/api/commonshift/connectCommonShiftsToAreas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConnectCommonShiftsToAreas(_response);
        });
    }

    protected processConnectCommonShiftsToAreas(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class PlanningComplianceClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    listNonComplianceForAreaAndCalendarDate(areaId: number, startTime: Date, endTime: Date): Promise<PlanningComplianceItem[]> {
        let url_ = this.baseUrl + "/workschedule/api/planning-compliance/list/non-compliance/area/{areaId}/{startTime}/{endTime}";
        if (areaId === undefined || areaId === null)
            throw new Error("The parameter 'areaId' must be defined.");
        url_ = url_.replace("{areaId}", encodeURIComponent("" + areaId));
        if (startTime === undefined || startTime === null)
            throw new Error("The parameter 'startTime' must be defined.");
        url_ = url_.replace("{startTime}", encodeURIComponent(startTime ? "" + startTime.toISOString() : "null"));
        if (endTime === undefined || endTime === null)
            throw new Error("The parameter 'endTime' must be defined.");
        url_ = url_.replace("{endTime}", encodeURIComponent(endTime ? "" + endTime.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListNonComplianceForAreaAndCalendarDate(_response);
        });
    }

    protected processListNonComplianceForAreaAndCalendarDate(response: Response): Promise<PlanningComplianceItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlanningComplianceItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlanningComplianceItem[]>(null as any);
    }

    listNonComplianceForPlannedRoute(plannedRouteId: number): Promise<PlanningComplianceItem[]> {
        let url_ = this.baseUrl + "/workschedule/api/planning-compliance/list/non-compliance/planned-route/{plannedRouteId}";
        if (plannedRouteId === undefined || plannedRouteId === null)
            throw new Error("The parameter 'plannedRouteId' must be defined.");
        url_ = url_.replace("{plannedRouteId}", encodeURIComponent("" + plannedRouteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListNonComplianceForPlannedRoute(_response);
        });
    }

    protected processListNonComplianceForPlannedRoute(response: Response): Promise<PlanningComplianceItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlanningComplianceItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlanningComplianceItem[]>(null as any);
    }

    listNonComplianceForPlannedRouteAndUser(plannedRouteId: number, userId: number): Promise<PlanningComplianceItem[]> {
        let url_ = this.baseUrl + "/workschedule/api/planning-compliance/list/non-compliance/planned-route/{plannedRouteId}/user/{userId}";
        if (plannedRouteId === undefined || plannedRouteId === null)
            throw new Error("The parameter 'plannedRouteId' must be defined.");
        url_ = url_.replace("{plannedRouteId}", encodeURIComponent("" + plannedRouteId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListNonComplianceForPlannedRouteAndUser(_response);
        });
    }

    protected processListNonComplianceForPlannedRouteAndUser(response: Response): Promise<PlanningComplianceItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlanningComplianceItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlanningComplianceItem[]>(null as any);
    }

    listNonCompliantRoutesForPlannedUserWorkSchedule(plannedUserWorkScheduleId: number): Promise<NonCompliantRouteItem[]> {
        let url_ = this.baseUrl + "/workschedule/api/planning-compliance/list/non-compliant-routes/planneduserworkscheduleid/{plannedUserWorkScheduleId}";
        if (plannedUserWorkScheduleId === undefined || plannedUserWorkScheduleId === null)
            throw new Error("The parameter 'plannedUserWorkScheduleId' must be defined.");
        url_ = url_.replace("{plannedUserWorkScheduleId}", encodeURIComponent("" + plannedUserWorkScheduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListNonCompliantRoutesForPlannedUserWorkSchedule(_response);
        });
    }

    protected processListNonCompliantRoutesForPlannedUserWorkSchedule(response: Response): Promise<NonCompliantRouteItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NonCompliantRouteItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NonCompliantRouteItem[]>(null as any);
    }

    listNonCompliantRoutesAndTimesForPlannedActivity(plannedActivityRowId: number): Promise<NonCompliantRouteTimesItem[]> {
        let url_ = this.baseUrl + "/workschedule/api/planning-compliance/list/non-compliant-routes-and-times/plannedActivityRowId/{plannedActivityRowId}";
        if (plannedActivityRowId === undefined || plannedActivityRowId === null)
            throw new Error("The parameter 'plannedActivityRowId' must be defined.");
        url_ = url_.replace("{plannedActivityRowId}", encodeURIComponent("" + plannedActivityRowId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListNonCompliantRoutesAndTimesForPlannedActivity(_response);
        });
    }

    protected processListNonCompliantRoutesAndTimesForPlannedActivity(response: Response): Promise<NonCompliantRouteTimesItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NonCompliantRouteTimesItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NonCompliantRouteTimesItem[]>(null as any);
    }
}

export class UserWorkScheduleClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    createPlannedRouteUserWorkSchedule(model: PlannedRouteUserWorkScheduleCreateItem): Promise<PlannedRouteUserWorkScheduleItem> {
        let url_ = this.baseUrl + "/workschedule/api/userworkschedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreatePlannedRouteUserWorkSchedule(_response);
        });
    }

    protected processCreatePlannedRouteUserWorkSchedule(response: Response): Promise<PlannedRouteUserWorkScheduleItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlannedRouteUserWorkScheduleItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlannedRouteUserWorkScheduleItem>(null as any);
    }

    updatePlannedRouteUserWorkSchedule(model: PlannedRouteUserWorkScheduleUpdateItem): Promise<PlannedRouteUserWorkScheduleItem> {
        let url_ = this.baseUrl + "/workschedule/api/userworkschedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePlannedRouteUserWorkSchedule(_response);
        });
    }

    protected processUpdatePlannedRouteUserWorkSchedule(response: Response): Promise<PlannedRouteUserWorkScheduleItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlannedRouteUserWorkScheduleItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlannedRouteUserWorkScheduleItem>(null as any);
    }

    getSinglePlannedRouteUserWorkSchedule(id: number): Promise<PlannedRouteUserWorkScheduleItem> {
        let url_ = this.baseUrl + "/workschedule/api/userworkschedule/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSinglePlannedRouteUserWorkSchedule(_response);
        });
    }

    protected processGetSinglePlannedRouteUserWorkSchedule(response: Response): Promise<PlannedRouteUserWorkScheduleItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlannedRouteUserWorkScheduleItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlannedRouteUserWorkScheduleItem>(null as any);
    }

    deletePlannedRouteUserWorkSchedule(id: number): Promise<PlannedRouteUserWorkScheduleItem> {
        let url_ = this.baseUrl + "/workschedule/api/userworkschedule/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeletePlannedRouteUserWorkSchedule(_response);
        });
    }

    protected processDeletePlannedRouteUserWorkSchedule(response: Response): Promise<PlannedRouteUserWorkScheduleItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlannedRouteUserWorkScheduleItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlannedRouteUserWorkScheduleItem>(null as any);
    }

    movePlannedRouteUserWorkSchedule(model: MovePlannedRouteUserWorkScheduleItem): Promise<PlannedRouteUserWorkScheduleItem> {
        let url_ = this.baseUrl + "/workschedule/api/userworkschedule/movePlannedRouteUserWorkSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMovePlannedRouteUserWorkSchedule(_response);
        });
    }

    protected processMovePlannedRouteUserWorkSchedule(response: Response): Promise<PlannedRouteUserWorkScheduleItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlannedRouteUserWorkScheduleItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlannedRouteUserWorkScheduleItem>(null as any);
    }

    unplanPlannedRouteUserWorkSchedule(model: PlannedRouteUserWorkScheduleUpdateItem): Promise<PlannedRouteUserWorkScheduleItem> {
        let url_ = this.baseUrl + "/workschedule/api/userworkschedule/unplanPlannedRouteUserWorkSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnplanPlannedRouteUserWorkSchedule(_response);
        });
    }

    protected processUnplanPlannedRouteUserWorkSchedule(response: Response): Promise<PlannedRouteUserWorkScheduleItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlannedRouteUserWorkScheduleItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlannedRouteUserWorkScheduleItem>(null as any);
    }

    listLatestUserWorkSchedules(userId: number, calendarStartDate: Date): Promise<LatestUserWorkScheduleItem[]> {
        let url_ = this.baseUrl + "/workschedule/api/userworkschedule/listlatest/userid/{userId}/calendarStartDate/{calendarStartDate}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (calendarStartDate === undefined || calendarStartDate === null)
            throw new Error("The parameter 'calendarStartDate' must be defined.");
        url_ = url_.replace("{calendarStartDate}", encodeURIComponent(calendarStartDate ? "" + calendarStartDate.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListLatestUserWorkSchedules(_response);
        });
    }

    protected processListLatestUserWorkSchedules(response: Response): Promise<LatestUserWorkScheduleItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LatestUserWorkScheduleItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LatestUserWorkScheduleItem[]>(null as any);
    }

    generateUserWorkScheduleReport(startDate: Date, endDate: Date, areaIds: number[]): Promise<PlannedRouteUserWorkScheduleReportItem[]> {
        let url_ = this.baseUrl + "/workschedule/api/userworkschedule/generateuserschedulereport/{startDate}/{endDate}";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined.");
        url_ = url_.replace("{startDate}", encodeURIComponent(startDate ? "" + startDate.toISOString() : "null"));
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined.");
        url_ = url_.replace("{endDate}", encodeURIComponent(endDate ? "" + endDate.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(areaIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateUserWorkScheduleReport(_response);
        });
    }

    protected processGenerateUserWorkScheduleReport(response: Response): Promise<PlannedRouteUserWorkScheduleReportItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlannedRouteUserWorkScheduleReportItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlannedRouteUserWorkScheduleReportItem[]>(null as any);
    }

    getRouteIdForUserWorkSchedule(userId: number): Promise<number> {
        let url_ = this.baseUrl + "/workschedule/api/userworkschedule/routeid/userid/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRouteIdForUserWorkSchedule(_response);
        });
    }

    protected processGetRouteIdForUserWorkSchedule(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    listCurrentDayPlannedUserWorkSchedulesOnArea(areaId: number): Promise<PlannedRouteUserWorkScheduleItem[]> {
        let url_ = this.baseUrl + "/workschedule/api/userworkschedule/listcurrentday/areaid/{areaId}";
        if (areaId === undefined || areaId === null)
            throw new Error("The parameter 'areaId' must be defined.");
        url_ = url_.replace("{areaId}", encodeURIComponent("" + areaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListCurrentDayPlannedUserWorkSchedulesOnArea(_response);
        });
    }

    protected processListCurrentDayPlannedUserWorkSchedulesOnArea(response: Response): Promise<PlannedRouteUserWorkScheduleItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlannedRouteUserWorkScheduleItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlannedRouteUserWorkScheduleItem[]>(null as any);
    }

    generateGapReport(startDate: Date, endDate: Date, areaIds: number[]): Promise<GapReportItem[]> {
        let url_ = this.baseUrl + "/workschedule/api/userworkschedule/generategapreport/{startDate}/{endDate}";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined.");
        url_ = url_.replace("{startDate}", encodeURIComponent(startDate ? "" + startDate.toISOString() : "null"));
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined.");
        url_ = url_.replace("{endDate}", encodeURIComponent(endDate ? "" + endDate.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(areaIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateGapReport(_response);
        });
    }

    protected processGenerateGapReport(response: Response): Promise<GapReportItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GapReportItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GapReportItem[]>(null as any);
    }

    listFuturePlannedUserWorkSchedulesOnUser(userId: number, areaId: number, plannedRouteUserWorkScheduleId: number): Promise<PlannedRouteUserWorkScheduleItem[]> {
        let url_ = this.baseUrl + "/workschedule/api/userworkschedule/listfutureplanneduserworkschedules/userid/{userId}/areaid/{areaId}/plannedrouteuserworkscheduleid/{plannedRouteUserWorkScheduleId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (areaId === undefined || areaId === null)
            throw new Error("The parameter 'areaId' must be defined.");
        url_ = url_.replace("{areaId}", encodeURIComponent("" + areaId));
        if (plannedRouteUserWorkScheduleId === undefined || plannedRouteUserWorkScheduleId === null)
            throw new Error("The parameter 'plannedRouteUserWorkScheduleId' must be defined.");
        url_ = url_.replace("{plannedRouteUserWorkScheduleId}", encodeURIComponent("" + plannedRouteUserWorkScheduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListFuturePlannedUserWorkSchedulesOnUser(_response);
        });
    }

    protected processListFuturePlannedUserWorkSchedulesOnUser(response: Response): Promise<PlannedRouteUserWorkScheduleItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlannedRouteUserWorkScheduleItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlannedRouteUserWorkScheduleItem[]>(null as any);
    }

    updateMultiplePlannedUserWorkSchedules(model: UpdateMultiplePlannedUserWorkScheduleItem[]): Promise<PlannedRouteUserWorkScheduleItem[]> {
        let url_ = this.baseUrl + "/workschedule/api/userworkschedule/updatemultipleplanneduserworkschedules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateMultiplePlannedUserWorkSchedules(_response);
        });
    }

    protected processUpdateMultiplePlannedUserWorkSchedules(response: Response): Promise<PlannedRouteUserWorkScheduleItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlannedRouteUserWorkScheduleItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlannedRouteUserWorkScheduleItem[]>(null as any);
    }
}

export class VersionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAppVersion(): Promise<string> {
        let url_ = this.baseUrl + "/workschedule/api/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAppVersion(_response);
        });
    }

    protected processGetAppVersion(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class CommonShiftItem implements ICommonShiftItem {
    id!: number;
    scheduledStartTimeTicks!: number;
    scheduledEndTimeTicks!: number;
    description!: string;

    constructor(data?: ICommonShiftItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.scheduledStartTimeTicks = _data["scheduledStartTimeTicks"];
            this.scheduledEndTimeTicks = _data["scheduledEndTimeTicks"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CommonShiftItem {
        data = typeof data === 'object' ? data : {};
        let result = new CommonShiftItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["scheduledStartTimeTicks"] = this.scheduledStartTimeTicks;
        data["scheduledEndTimeTicks"] = this.scheduledEndTimeTicks;
        data["description"] = this.description;
        return data;
    }
}

export interface ICommonShiftItem {
    id: number;
    scheduledStartTimeTicks: number;
    scheduledEndTimeTicks: number;
    description: string;
}

export class CommonShiftCreateItem implements ICommonShiftCreateItem {
    scheduledStartTimeTicks!: number;
    scheduledEndTimeTicks!: number;
    description!: string;
    organizationId!: number;

    constructor(data?: ICommonShiftCreateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scheduledStartTimeTicks = _data["scheduledStartTimeTicks"];
            this.scheduledEndTimeTicks = _data["scheduledEndTimeTicks"];
            this.description = _data["description"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): CommonShiftCreateItem {
        data = typeof data === 'object' ? data : {};
        let result = new CommonShiftCreateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scheduledStartTimeTicks"] = this.scheduledStartTimeTicks;
        data["scheduledEndTimeTicks"] = this.scheduledEndTimeTicks;
        data["description"] = this.description;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface ICommonShiftCreateItem {
    scheduledStartTimeTicks: number;
    scheduledEndTimeTicks: number;
    description: string;
    organizationId: number;
}

export class CommonShiftUpdateItem implements ICommonShiftUpdateItem {
    id!: number;
    scheduledStartTimeTicks!: number;
    scheduledEndTimeTicks!: number;
    description!: string;
    organizationId!: number;

    constructor(data?: ICommonShiftUpdateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.scheduledStartTimeTicks = _data["scheduledStartTimeTicks"];
            this.scheduledEndTimeTicks = _data["scheduledEndTimeTicks"];
            this.description = _data["description"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): CommonShiftUpdateItem {
        data = typeof data === 'object' ? data : {};
        let result = new CommonShiftUpdateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["scheduledStartTimeTicks"] = this.scheduledStartTimeTicks;
        data["scheduledEndTimeTicks"] = this.scheduledEndTimeTicks;
        data["description"] = this.description;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface ICommonShiftUpdateItem {
    id: number;
    scheduledStartTimeTicks: number;
    scheduledEndTimeTicks: number;
    description: string;
    organizationId: number;
}

export class CommonShiftListItem implements ICommonShiftListItem {
    id!: number;
    scheduledStartTimeTicks!: number;
    scheduledEndTimeTicks!: number;
    description!: string;

    constructor(data?: ICommonShiftListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.scheduledStartTimeTicks = _data["scheduledStartTimeTicks"];
            this.scheduledEndTimeTicks = _data["scheduledEndTimeTicks"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CommonShiftListItem {
        data = typeof data === 'object' ? data : {};
        let result = new CommonShiftListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["scheduledStartTimeTicks"] = this.scheduledStartTimeTicks;
        data["scheduledEndTimeTicks"] = this.scheduledEndTimeTicks;
        data["description"] = this.description;
        return data;
    }
}

export interface ICommonShiftListItem {
    id: number;
    scheduledStartTimeTicks: number;
    scheduledEndTimeTicks: number;
    description: string;
}

export class CommonShiftInheritanceItem implements ICommonShiftInheritanceItem {
    id!: number;
    workScheduleCommonShiftId!: number;
    areaId!: number;
    areaName!: string;
    areaOrganizationParentsName!: string;
    commonShiftScheduledStartTimeTicks!: number;
    commonShiftScheduledEndTimeTicks!: number;
    commonShiftDescription!: string;

    constructor(data?: ICommonShiftInheritanceItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workScheduleCommonShiftId = _data["workScheduleCommonShiftId"];
            this.areaId = _data["areaId"];
            this.areaName = _data["areaName"];
            this.areaOrganizationParentsName = _data["areaOrganizationParentsName"];
            this.commonShiftScheduledStartTimeTicks = _data["commonShiftScheduledStartTimeTicks"];
            this.commonShiftScheduledEndTimeTicks = _data["commonShiftScheduledEndTimeTicks"];
            this.commonShiftDescription = _data["commonShiftDescription"];
        }
    }

    static fromJS(data: any): CommonShiftInheritanceItem {
        data = typeof data === 'object' ? data : {};
        let result = new CommonShiftInheritanceItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workScheduleCommonShiftId"] = this.workScheduleCommonShiftId;
        data["areaId"] = this.areaId;
        data["areaName"] = this.areaName;
        data["areaOrganizationParentsName"] = this.areaOrganizationParentsName;
        data["commonShiftScheduledStartTimeTicks"] = this.commonShiftScheduledStartTimeTicks;
        data["commonShiftScheduledEndTimeTicks"] = this.commonShiftScheduledEndTimeTicks;
        data["commonShiftDescription"] = this.commonShiftDescription;
        return data;
    }
}

export interface ICommonShiftInheritanceItem {
    id: number;
    workScheduleCommonShiftId: number;
    areaId: number;
    areaName: string;
    areaOrganizationParentsName: string;
    commonShiftScheduledStartTimeTicks: number;
    commonShiftScheduledEndTimeTicks: number;
    commonShiftDescription: string;
}

export class CommonShiftInheritanceCreateItem implements ICommonShiftInheritanceCreateItem {
    workScheduleCommonShiftId!: number;
    areaId!: number;

    constructor(data?: ICommonShiftInheritanceCreateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workScheduleCommonShiftId = _data["workScheduleCommonShiftId"];
            this.areaId = _data["areaId"];
        }
    }

    static fromJS(data: any): CommonShiftInheritanceCreateItem {
        data = typeof data === 'object' ? data : {};
        let result = new CommonShiftInheritanceCreateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workScheduleCommonShiftId"] = this.workScheduleCommonShiftId;
        data["areaId"] = this.areaId;
        return data;
    }
}

export interface ICommonShiftInheritanceCreateItem {
    workScheduleCommonShiftId: number;
    areaId: number;
}

export class CommonShiftInheritanceUpdateItem implements ICommonShiftInheritanceUpdateItem {
    id!: number;
    workScheduleCommonShiftId!: number;
    areaId!: number;

    constructor(data?: ICommonShiftInheritanceUpdateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workScheduleCommonShiftId = _data["workScheduleCommonShiftId"];
            this.areaId = _data["areaId"];
        }
    }

    static fromJS(data: any): CommonShiftInheritanceUpdateItem {
        data = typeof data === 'object' ? data : {};
        let result = new CommonShiftInheritanceUpdateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workScheduleCommonShiftId"] = this.workScheduleCommonShiftId;
        data["areaId"] = this.areaId;
        return data;
    }
}

export interface ICommonShiftInheritanceUpdateItem {
    id: number;
    workScheduleCommonShiftId: number;
    areaId: number;
}

export class CommonShiftsToAreasItem implements ICommonShiftsToAreasItem {
    commonShiftsIds!: number[];
    areaIds!: number[];

    constructor(data?: ICommonShiftsToAreasItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.commonShiftsIds = [];
            this.areaIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["commonShiftsIds"])) {
                this.commonShiftsIds = [] as any;
                for (let item of _data["commonShiftsIds"])
                    this.commonShiftsIds!.push(item);
            }
            if (Array.isArray(_data["areaIds"])) {
                this.areaIds = [] as any;
                for (let item of _data["areaIds"])
                    this.areaIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CommonShiftsToAreasItem {
        data = typeof data === 'object' ? data : {};
        let result = new CommonShiftsToAreasItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.commonShiftsIds)) {
            data["commonShiftsIds"] = [];
            for (let item of this.commonShiftsIds)
                data["commonShiftsIds"].push(item);
        }
        if (Array.isArray(this.areaIds)) {
            data["areaIds"] = [];
            for (let item of this.areaIds)
                data["areaIds"].push(item);
        }
        return data;
    }
}

export interface ICommonShiftsToAreasItem {
    commonShiftsIds: number[];
    areaIds: number[];
}

export class PlanningComplianceItem implements IPlanningComplianceItem {
    routeId!: number;
    plannedRouteIds!: number[];
    nonCompliantUserWorkSchedules!: NonCompliantUserWorkScheduleItem[];
    notSatisfiedPlannedActivities!: NotSatisfiedPlannedActivityItem[];
    plannedActivitiesOutsideWorkSchedules!: PlannedActivityOutsideWorkScheduleItem[];
    workSchedulesInConflict!: WorkSchedulesInConflictItem[];

    constructor(data?: IPlanningComplianceItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.plannedRouteIds = [];
            this.nonCompliantUserWorkSchedules = [];
            this.notSatisfiedPlannedActivities = [];
            this.plannedActivitiesOutsideWorkSchedules = [];
            this.workSchedulesInConflict = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.routeId = _data["routeId"];
            if (Array.isArray(_data["plannedRouteIds"])) {
                this.plannedRouteIds = [] as any;
                for (let item of _data["plannedRouteIds"])
                    this.plannedRouteIds!.push(item);
            }
            if (Array.isArray(_data["nonCompliantUserWorkSchedules"])) {
                this.nonCompliantUserWorkSchedules = [] as any;
                for (let item of _data["nonCompliantUserWorkSchedules"])
                    this.nonCompliantUserWorkSchedules!.push(NonCompliantUserWorkScheduleItem.fromJS(item));
            }
            if (Array.isArray(_data["notSatisfiedPlannedActivities"])) {
                this.notSatisfiedPlannedActivities = [] as any;
                for (let item of _data["notSatisfiedPlannedActivities"])
                    this.notSatisfiedPlannedActivities!.push(NotSatisfiedPlannedActivityItem.fromJS(item));
            }
            if (Array.isArray(_data["plannedActivitiesOutsideWorkSchedules"])) {
                this.plannedActivitiesOutsideWorkSchedules = [] as any;
                for (let item of _data["plannedActivitiesOutsideWorkSchedules"])
                    this.plannedActivitiesOutsideWorkSchedules!.push(PlannedActivityOutsideWorkScheduleItem.fromJS(item));
            }
            if (Array.isArray(_data["workSchedulesInConflict"])) {
                this.workSchedulesInConflict = [] as any;
                for (let item of _data["workSchedulesInConflict"])
                    this.workSchedulesInConflict!.push(WorkSchedulesInConflictItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlanningComplianceItem {
        data = typeof data === 'object' ? data : {};
        let result = new PlanningComplianceItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["routeId"] = this.routeId;
        if (Array.isArray(this.plannedRouteIds)) {
            data["plannedRouteIds"] = [];
            for (let item of this.plannedRouteIds)
                data["plannedRouteIds"].push(item);
        }
        if (Array.isArray(this.nonCompliantUserWorkSchedules)) {
            data["nonCompliantUserWorkSchedules"] = [];
            for (let item of this.nonCompliantUserWorkSchedules)
                data["nonCompliantUserWorkSchedules"].push(item.toJSON());
        }
        if (Array.isArray(this.notSatisfiedPlannedActivities)) {
            data["notSatisfiedPlannedActivities"] = [];
            for (let item of this.notSatisfiedPlannedActivities)
                data["notSatisfiedPlannedActivities"].push(item.toJSON());
        }
        if (Array.isArray(this.plannedActivitiesOutsideWorkSchedules)) {
            data["plannedActivitiesOutsideWorkSchedules"] = [];
            for (let item of this.plannedActivitiesOutsideWorkSchedules)
                data["plannedActivitiesOutsideWorkSchedules"].push(item.toJSON());
        }
        if (Array.isArray(this.workSchedulesInConflict)) {
            data["workSchedulesInConflict"] = [];
            for (let item of this.workSchedulesInConflict)
                data["workSchedulesInConflict"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlanningComplianceItem {
    routeId: number;
    plannedRouteIds: number[];
    nonCompliantUserWorkSchedules: NonCompliantUserWorkScheduleItem[];
    notSatisfiedPlannedActivities: NotSatisfiedPlannedActivityItem[];
    plannedActivitiesOutsideWorkSchedules: PlannedActivityOutsideWorkScheduleItem[];
    workSchedulesInConflict: WorkSchedulesInConflictItem[];
}

export class NonCompliantUserWorkScheduleItem implements INonCompliantUserWorkScheduleItem {
    plannedRouteUserWorkSchedule!: PlannedRouteUserWorkScheduleItem;
    notFulfilledDelegations!: FulfilledDelegationItem[];

    constructor(data?: INonCompliantUserWorkScheduleItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.plannedRouteUserWorkSchedule = new PlannedRouteUserWorkScheduleItem();
            this.notFulfilledDelegations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plannedRouteUserWorkSchedule = _data["plannedRouteUserWorkSchedule"] ? PlannedRouteUserWorkScheduleItem.fromJS(_data["plannedRouteUserWorkSchedule"]) : new PlannedRouteUserWorkScheduleItem();
            if (Array.isArray(_data["notFulfilledDelegations"])) {
                this.notFulfilledDelegations = [] as any;
                for (let item of _data["notFulfilledDelegations"])
                    this.notFulfilledDelegations!.push(FulfilledDelegationItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NonCompliantUserWorkScheduleItem {
        data = typeof data === 'object' ? data : {};
        let result = new NonCompliantUserWorkScheduleItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plannedRouteUserWorkSchedule"] = this.plannedRouteUserWorkSchedule ? this.plannedRouteUserWorkSchedule.toJSON() : <any>undefined;
        if (Array.isArray(this.notFulfilledDelegations)) {
            data["notFulfilledDelegations"] = [];
            for (let item of this.notFulfilledDelegations)
                data["notFulfilledDelegations"].push(item.toJSON());
        }
        return data;
    }
}

export interface INonCompliantUserWorkScheduleItem {
    plannedRouteUserWorkSchedule: PlannedRouteUserWorkScheduleItem;
    notFulfilledDelegations: FulfilledDelegationItem[];
}

export class PlannedRouteUserWorkScheduleItem implements IPlannedRouteUserWorkScheduleItem {
    id!: number;
    scheduledStart!: Date;
    scheduledEnd!: Date;
    plannedRouteId!: number;
    routeId!: number;
    routeName!: string;
    userId!: number;
    userFullName!: string;
    substituteUserId?: number | undefined;
    substituteUserFullName?: string | undefined;
    areaId!: number;
    areaName!: string;

    constructor(data?: IPlannedRouteUserWorkScheduleItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.scheduledStart = _data["scheduledStart"] ? new Date(_data["scheduledStart"].toString()) : <any>undefined;
            this.scheduledEnd = _data["scheduledEnd"] ? new Date(_data["scheduledEnd"].toString()) : <any>undefined;
            this.plannedRouteId = _data["plannedRouteId"];
            this.routeId = _data["routeId"];
            this.routeName = _data["routeName"];
            this.userId = _data["userId"];
            this.userFullName = _data["userFullName"];
            this.substituteUserId = _data["substituteUserId"];
            this.substituteUserFullName = _data["substituteUserFullName"];
            this.areaId = _data["areaId"];
            this.areaName = _data["areaName"];
        }
    }

    static fromJS(data: any): PlannedRouteUserWorkScheduleItem {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedRouteUserWorkScheduleItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["scheduledStart"] = this.scheduledStart ? this.scheduledStart.toISOString() : <any>undefined;
        data["scheduledEnd"] = this.scheduledEnd ? this.scheduledEnd.toISOString() : <any>undefined;
        data["plannedRouteId"] = this.plannedRouteId;
        data["routeId"] = this.routeId;
        data["routeName"] = this.routeName;
        data["userId"] = this.userId;
        data["userFullName"] = this.userFullName;
        data["substituteUserId"] = this.substituteUserId;
        data["substituteUserFullName"] = this.substituteUserFullName;
        data["areaId"] = this.areaId;
        data["areaName"] = this.areaName;
        return data;
    }
}

export interface IPlannedRouteUserWorkScheduleItem {
    id: number;
    scheduledStart: Date;
    scheduledEnd: Date;
    plannedRouteId: number;
    routeId: number;
    routeName: string;
    userId: number;
    userFullName: string;
    substituteUserId?: number | undefined;
    substituteUserFullName?: string | undefined;
    areaId: number;
    areaName: string;
}

export class FulfilledDelegationItem implements IFulfilledDelegationItem {
    id!: number;
    title!: string;
    isFulfilled!: boolean;
    requiredAtAreaId?: number | undefined;
    requiredAtCustomerId?: number | undefined;
    plannedActivityRowId!: number;
    plannedRouteId!: number;

    constructor(data?: IFulfilledDelegationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.isFulfilled = _data["isFulfilled"];
            this.requiredAtAreaId = _data["requiredAtAreaId"];
            this.requiredAtCustomerId = _data["requiredAtCustomerId"];
            this.plannedActivityRowId = _data["plannedActivityRowId"];
            this.plannedRouteId = _data["plannedRouteId"];
        }
    }

    static fromJS(data: any): FulfilledDelegationItem {
        data = typeof data === 'object' ? data : {};
        let result = new FulfilledDelegationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["isFulfilled"] = this.isFulfilled;
        data["requiredAtAreaId"] = this.requiredAtAreaId;
        data["requiredAtCustomerId"] = this.requiredAtCustomerId;
        data["plannedActivityRowId"] = this.plannedActivityRowId;
        data["plannedRouteId"] = this.plannedRouteId;
        return data;
    }
}

export interface IFulfilledDelegationItem {
    id: number;
    title: string;
    isFulfilled: boolean;
    requiredAtAreaId?: number | undefined;
    requiredAtCustomerId?: number | undefined;
    plannedActivityRowId: number;
    plannedRouteId: number;
}

export class NotSatisfiedPlannedActivityItem implements INotSatisfiedPlannedActivityItem {
    plannedActivityId!: number;
    notFulfilledDelegations!: FulfilledDelegationItem[];
    title!: string;
    customerName?: string | undefined;
    startTime!: Date;
    endTime!: Date;

    constructor(data?: INotSatisfiedPlannedActivityItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.notFulfilledDelegations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plannedActivityId = _data["plannedActivityId"];
            if (Array.isArray(_data["notFulfilledDelegations"])) {
                this.notFulfilledDelegations = [] as any;
                for (let item of _data["notFulfilledDelegations"])
                    this.notFulfilledDelegations!.push(FulfilledDelegationItem.fromJS(item));
            }
            this.title = _data["title"];
            this.customerName = _data["customerName"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NotSatisfiedPlannedActivityItem {
        data = typeof data === 'object' ? data : {};
        let result = new NotSatisfiedPlannedActivityItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plannedActivityId"] = this.plannedActivityId;
        if (Array.isArray(this.notFulfilledDelegations)) {
            data["notFulfilledDelegations"] = [];
            for (let item of this.notFulfilledDelegations)
                data["notFulfilledDelegations"].push(item.toJSON());
        }
        data["title"] = this.title;
        data["customerName"] = this.customerName;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface INotSatisfiedPlannedActivityItem {
    plannedActivityId: number;
    notFulfilledDelegations: FulfilledDelegationItem[];
    title: string;
    customerName?: string | undefined;
    startTime: Date;
    endTime: Date;
}

export class PlannedActivityOutsideWorkScheduleItem implements IPlannedActivityOutsideWorkScheduleItem {
    plannedActivityId!: number;
    title?: string | undefined;
    customerName?: string | undefined;
    startTime!: Date;
    endTime!: Date;

    constructor(data?: IPlannedActivityOutsideWorkScheduleItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plannedActivityId = _data["plannedActivityId"];
            this.title = _data["title"];
            this.customerName = _data["customerName"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PlannedActivityOutsideWorkScheduleItem {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedActivityOutsideWorkScheduleItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plannedActivityId"] = this.plannedActivityId;
        data["title"] = this.title;
        data["customerName"] = this.customerName;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPlannedActivityOutsideWorkScheduleItem {
    plannedActivityId: number;
    title?: string | undefined;
    customerName?: string | undefined;
    startTime: Date;
    endTime: Date;
}

export class WorkSchedulesInConflictItem implements IWorkSchedulesInConflictItem {
    plannedRouteUserWorkSchedule!: PlannedRouteUserWorkScheduleItem;
    conflictingWorkSchedules!: PlannedRouteUserWorkScheduleItem[];

    constructor(data?: IWorkSchedulesInConflictItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.plannedRouteUserWorkSchedule = new PlannedRouteUserWorkScheduleItem();
            this.conflictingWorkSchedules = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plannedRouteUserWorkSchedule = _data["plannedRouteUserWorkSchedule"] ? PlannedRouteUserWorkScheduleItem.fromJS(_data["plannedRouteUserWorkSchedule"]) : new PlannedRouteUserWorkScheduleItem();
            if (Array.isArray(_data["conflictingWorkSchedules"])) {
                this.conflictingWorkSchedules = [] as any;
                for (let item of _data["conflictingWorkSchedules"])
                    this.conflictingWorkSchedules!.push(PlannedRouteUserWorkScheduleItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkSchedulesInConflictItem {
        data = typeof data === 'object' ? data : {};
        let result = new WorkSchedulesInConflictItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plannedRouteUserWorkSchedule"] = this.plannedRouteUserWorkSchedule ? this.plannedRouteUserWorkSchedule.toJSON() : <any>undefined;
        if (Array.isArray(this.conflictingWorkSchedules)) {
            data["conflictingWorkSchedules"] = [];
            for (let item of this.conflictingWorkSchedules)
                data["conflictingWorkSchedules"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWorkSchedulesInConflictItem {
    plannedRouteUserWorkSchedule: PlannedRouteUserWorkScheduleItem;
    conflictingWorkSchedules: PlannedRouteUserWorkScheduleItem[];
}

export class NonCompliantRouteItem implements INonCompliantRouteItem {
    routeId!: number;

    constructor(data?: INonCompliantRouteItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.routeId = _data["routeId"];
        }
    }

    static fromJS(data: any): NonCompliantRouteItem {
        data = typeof data === 'object' ? data : {};
        let result = new NonCompliantRouteItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["routeId"] = this.routeId;
        return data;
    }
}

export interface INonCompliantRouteItem {
    routeId: number;
}

export class NonCompliantRouteTimesItem implements INonCompliantRouteTimesItem {
    routeId!: number;
    startTime!: Date;
    endTime!: Date;
    nonCompliantPlannedRouteWorkScheduleIds!: number[];

    constructor(data?: INonCompliantRouteTimesItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.nonCompliantPlannedRouteWorkScheduleIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.routeId = _data["routeId"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["nonCompliantPlannedRouteWorkScheduleIds"])) {
                this.nonCompliantPlannedRouteWorkScheduleIds = [] as any;
                for (let item of _data["nonCompliantPlannedRouteWorkScheduleIds"])
                    this.nonCompliantPlannedRouteWorkScheduleIds!.push(item);
            }
        }
    }

    static fromJS(data: any): NonCompliantRouteTimesItem {
        data = typeof data === 'object' ? data : {};
        let result = new NonCompliantRouteTimesItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["routeId"] = this.routeId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        if (Array.isArray(this.nonCompliantPlannedRouteWorkScheduleIds)) {
            data["nonCompliantPlannedRouteWorkScheduleIds"] = [];
            for (let item of this.nonCompliantPlannedRouteWorkScheduleIds)
                data["nonCompliantPlannedRouteWorkScheduleIds"].push(item);
        }
        return data;
    }
}

export interface INonCompliantRouteTimesItem {
    routeId: number;
    startTime: Date;
    endTime: Date;
    nonCompliantPlannedRouteWorkScheduleIds: number[];
}

export class PlannedRouteUserWorkScheduleCreateItem implements IPlannedRouteUserWorkScheduleCreateItem {
    scheduledStart!: Date;
    scheduledEnd!: Date;
    calendarDay!: Date;
    routeId!: number;
    userId!: number;

    constructor(data?: IPlannedRouteUserWorkScheduleCreateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scheduledStart = _data["scheduledStart"] ? new Date(_data["scheduledStart"].toString()) : <any>undefined;
            this.scheduledEnd = _data["scheduledEnd"] ? new Date(_data["scheduledEnd"].toString()) : <any>undefined;
            this.calendarDay = _data["calendarDay"] ? new Date(_data["calendarDay"].toString()) : <any>undefined;
            this.routeId = _data["routeId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): PlannedRouteUserWorkScheduleCreateItem {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedRouteUserWorkScheduleCreateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scheduledStart"] = this.scheduledStart ? this.scheduledStart.toISOString() : <any>undefined;
        data["scheduledEnd"] = this.scheduledEnd ? this.scheduledEnd.toISOString() : <any>undefined;
        data["calendarDay"] = this.calendarDay ? this.calendarDay.toISOString() : <any>undefined;
        data["routeId"] = this.routeId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IPlannedRouteUserWorkScheduleCreateItem {
    scheduledStart: Date;
    scheduledEnd: Date;
    calendarDay: Date;
    routeId: number;
    userId: number;
}

export class PlannedRouteUserWorkScheduleUpdateItem implements IPlannedRouteUserWorkScheduleUpdateItem {
    id!: number;
    scheduledStart!: Date;
    scheduledEnd!: Date;
    plannedRouteId!: number;
    userId!: number;
    substituteUserId?: number | undefined;
    substituteUserIdForAllSelected?: number | undefined;

    constructor(data?: IPlannedRouteUserWorkScheduleUpdateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.scheduledStart = _data["scheduledStart"] ? new Date(_data["scheduledStart"].toString()) : <any>undefined;
            this.scheduledEnd = _data["scheduledEnd"] ? new Date(_data["scheduledEnd"].toString()) : <any>undefined;
            this.plannedRouteId = _data["plannedRouteId"];
            this.userId = _data["userId"];
            this.substituteUserId = _data["substituteUserId"];
            this.substituteUserIdForAllSelected = _data["substituteUserIdForAllSelected"];
        }
    }

    static fromJS(data: any): PlannedRouteUserWorkScheduleUpdateItem {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedRouteUserWorkScheduleUpdateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["scheduledStart"] = this.scheduledStart ? this.scheduledStart.toISOString() : <any>undefined;
        data["scheduledEnd"] = this.scheduledEnd ? this.scheduledEnd.toISOString() : <any>undefined;
        data["plannedRouteId"] = this.plannedRouteId;
        data["userId"] = this.userId;
        data["substituteUserId"] = this.substituteUserId;
        data["substituteUserIdForAllSelected"] = this.substituteUserIdForAllSelected;
        return data;
    }
}

export interface IPlannedRouteUserWorkScheduleUpdateItem {
    id: number;
    scheduledStart: Date;
    scheduledEnd: Date;
    plannedRouteId: number;
    userId: number;
    substituteUserId?: number | undefined;
    substituteUserIdForAllSelected?: number | undefined;
}

export class MovePlannedRouteUserWorkScheduleItem implements IMovePlannedRouteUserWorkScheduleItem {
    id!: number;
    plannedRouteId!: number;
    userId!: number;
    newRouteId!: number;

    constructor(data?: IMovePlannedRouteUserWorkScheduleItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.plannedRouteId = _data["plannedRouteId"];
            this.userId = _data["userId"];
            this.newRouteId = _data["newRouteId"];
        }
    }

    static fromJS(data: any): MovePlannedRouteUserWorkScheduleItem {
        data = typeof data === 'object' ? data : {};
        let result = new MovePlannedRouteUserWorkScheduleItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["plannedRouteId"] = this.plannedRouteId;
        data["userId"] = this.userId;
        data["newRouteId"] = this.newRouteId;
        return data;
    }
}

export interface IMovePlannedRouteUserWorkScheduleItem {
    id: number;
    plannedRouteId: number;
    userId: number;
    newRouteId: number;
}

export class LatestUserWorkScheduleItem implements ILatestUserWorkScheduleItem {
    id!: number;
    scheduledStart!: Date;
    scheduledEnd!: Date;
    plannedRouteId!: number;
    routeName!: string;
    userId!: number;
    userFullName!: string;
    areaId!: number;
    areaName!: string;
    substituteUserFullName?: string | undefined;
    substituteUserId?: number | undefined;

    constructor(data?: ILatestUserWorkScheduleItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.scheduledStart = _data["scheduledStart"] ? new Date(_data["scheduledStart"].toString()) : <any>undefined;
            this.scheduledEnd = _data["scheduledEnd"] ? new Date(_data["scheduledEnd"].toString()) : <any>undefined;
            this.plannedRouteId = _data["plannedRouteId"];
            this.routeName = _data["routeName"];
            this.userId = _data["userId"];
            this.userFullName = _data["userFullName"];
            this.areaId = _data["areaId"];
            this.areaName = _data["areaName"];
            this.substituteUserFullName = _data["substituteUserFullName"];
            this.substituteUserId = _data["substituteUserId"];
        }
    }

    static fromJS(data: any): LatestUserWorkScheduleItem {
        data = typeof data === 'object' ? data : {};
        let result = new LatestUserWorkScheduleItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["scheduledStart"] = this.scheduledStart ? this.scheduledStart.toISOString() : <any>undefined;
        data["scheduledEnd"] = this.scheduledEnd ? this.scheduledEnd.toISOString() : <any>undefined;
        data["plannedRouteId"] = this.plannedRouteId;
        data["routeName"] = this.routeName;
        data["userId"] = this.userId;
        data["userFullName"] = this.userFullName;
        data["areaId"] = this.areaId;
        data["areaName"] = this.areaName;
        data["substituteUserFullName"] = this.substituteUserFullName;
        data["substituteUserId"] = this.substituteUserId;
        return data;
    }
}

export interface ILatestUserWorkScheduleItem {
    id: number;
    scheduledStart: Date;
    scheduledEnd: Date;
    plannedRouteId: number;
    routeName: string;
    userId: number;
    userFullName: string;
    areaId: number;
    areaName: string;
    substituteUserFullName?: string | undefined;
    substituteUserId?: number | undefined;
}

export class PlannedRouteUserWorkScheduleReportItem implements IPlannedRouteUserWorkScheduleReportItem {
    id!: number;
    scheduledStart!: Date;
    scheduledEnd!: Date;
    plannedRouteId!: number;
    routeId!: number;
    areaName!: string;
    routeName!: string;
    userId!: number;
    userFullName!: string;
    substituteUserFullName?: string | undefined;
    substituteUserId?: number | undefined;
    substituteCreatedById?: number | undefined;
    substituteCreatedOn?: Date | undefined;

    constructor(data?: IPlannedRouteUserWorkScheduleReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.scheduledStart = _data["scheduledStart"] ? new Date(_data["scheduledStart"].toString()) : <any>undefined;
            this.scheduledEnd = _data["scheduledEnd"] ? new Date(_data["scheduledEnd"].toString()) : <any>undefined;
            this.plannedRouteId = _data["plannedRouteId"];
            this.routeId = _data["routeId"];
            this.areaName = _data["areaName"];
            this.routeName = _data["routeName"];
            this.userId = _data["userId"];
            this.userFullName = _data["userFullName"];
            this.substituteUserFullName = _data["substituteUserFullName"];
            this.substituteUserId = _data["substituteUserId"];
            this.substituteCreatedById = _data["substituteCreatedById"];
            this.substituteCreatedOn = _data["substituteCreatedOn"] ? new Date(_data["substituteCreatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PlannedRouteUserWorkScheduleReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedRouteUserWorkScheduleReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["scheduledStart"] = this.scheduledStart ? this.scheduledStart.toISOString() : <any>undefined;
        data["scheduledEnd"] = this.scheduledEnd ? this.scheduledEnd.toISOString() : <any>undefined;
        data["plannedRouteId"] = this.plannedRouteId;
        data["routeId"] = this.routeId;
        data["areaName"] = this.areaName;
        data["routeName"] = this.routeName;
        data["userId"] = this.userId;
        data["userFullName"] = this.userFullName;
        data["substituteUserFullName"] = this.substituteUserFullName;
        data["substituteUserId"] = this.substituteUserId;
        data["substituteCreatedById"] = this.substituteCreatedById;
        data["substituteCreatedOn"] = this.substituteCreatedOn ? this.substituteCreatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPlannedRouteUserWorkScheduleReportItem {
    id: number;
    scheduledStart: Date;
    scheduledEnd: Date;
    plannedRouteId: number;
    routeId: number;
    areaName: string;
    routeName: string;
    userId: number;
    userFullName: string;
    substituteUserFullName?: string | undefined;
    substituteUserId?: number | undefined;
    substituteCreatedById?: number | undefined;
    substituteCreatedOn?: Date | undefined;
}

export class GapReportItem implements IGapReportItem {
    id!: number;
    calendarDate!: Date;
    areaId!: number;
    areaName!: string;
    routeId!: number;
    routeName!: string;
    gapStart!: Date;
    gapEnd!: Date;

    constructor(data?: IGapReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.calendarDate = _data["calendarDate"] ? new Date(_data["calendarDate"].toString()) : <any>undefined;
            this.areaId = _data["areaId"];
            this.areaName = _data["areaName"];
            this.routeId = _data["routeId"];
            this.routeName = _data["routeName"];
            this.gapStart = _data["gapStart"] ? new Date(_data["gapStart"].toString()) : <any>undefined;
            this.gapEnd = _data["gapEnd"] ? new Date(_data["gapEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GapReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new GapReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["calendarDate"] = this.calendarDate ? this.calendarDate.toISOString() : <any>undefined;
        data["areaId"] = this.areaId;
        data["areaName"] = this.areaName;
        data["routeId"] = this.routeId;
        data["routeName"] = this.routeName;
        data["gapStart"] = this.gapStart ? this.gapStart.toISOString() : <any>undefined;
        data["gapEnd"] = this.gapEnd ? this.gapEnd.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGapReportItem {
    id: number;
    calendarDate: Date;
    areaId: number;
    areaName: string;
    routeId: number;
    routeName: string;
    gapStart: Date;
    gapEnd: Date;
}

export class UpdateMultiplePlannedUserWorkScheduleItem implements IUpdateMultiplePlannedUserWorkScheduleItem {
    id!: number;
    substituteUserId?: number | undefined;

    constructor(data?: IUpdateMultiplePlannedUserWorkScheduleItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.substituteUserId = _data["substituteUserId"];
        }
    }

    static fromJS(data: any): UpdateMultiplePlannedUserWorkScheduleItem {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMultiplePlannedUserWorkScheduleItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["substituteUserId"] = this.substituteUserId;
        return data;
    }
}

export interface IUpdateMultiplePlannedUserWorkScheduleItem {
    id: number;
    substituteUserId?: number | undefined;
}

export abstract class ServiceError implements IServiceError {

    constructor(data?: IServiceError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ServiceError {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ServiceError' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IServiceError {
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}